import { Box, Button, Heading } from '@chakra-ui/react'

import { Container } from '../../../components/Container'
import { MainContent } from '../../../components/MainContent'
import { Section } from '../../../components/Section'
import { Steps } from '../../../components/Steps'
import { StepsContent } from '../../../context/StepsContext'
import { InsuranceSummary } from '../../../containers/InsuranceSummary'
import { MeetingRecordCarExtraOverview } from '../../../containers/MeetingRecordCarExtraOverview'
import { FormButtons } from '../../../containers/FormButtons'
import { Duplicate } from '../../../icons'
import { WithAuth } from '../../../containers/hoc/WithAuth'
import { useContext } from 'react'
import { addonOffersContext } from '../../../context/OfferAddonContext'
import { RecapExtraInsuranceSingle } from '../../../containers/carkulka/RecapExtraInsuranceSingle'
import { useCloneInsuranceParams } from '../../../hooks/useInsuranceParams'
import { insuranceParamsContext } from '../../../layouts/Wizard'
import { useNavigate } from 'react-router-dom'
import { baseUrl } from '../../../hooks'

const insuranceParamsApiUrl = process.env.REACT_APP_INSURANCEPARAMS_API
const insuranceParamsUrl = `${baseUrl}/${insuranceParamsApiUrl}`

const _CompletedPage = () => {
  const { insuranceParamsId } = useContext(insuranceParamsContext)
  const { addonOffers } = useContext(addonOffersContext)
  const { isLoading: isLoading } = useCloneInsuranceParams(insuranceParamsId!)

  const validAddonOffers = addonOffers?.filter(ao => ao.valid)

  return (
    <Section>
      <Container>
        <StepsContent step={4}>
          <Heading
            sx={{
              fontSize: '5xl',
              fontWeight: 'bold',
              letterSpacing: 'tighter',
              textAlign: 'center',
            }}
            as="h1"
          >
            Přehled sjednaného pojištění
          </Heading>

          <Steps icon="car" />

          <InsuranceSummary version='addon' />

          <MainContent>
            {validAddonOffers && validAddonOffers.length > 0 &&
              <Box
                sx={{
                  bg: 'gray.100',
                  mb: 8,
                  p: 4,
                  borderRadius: 'md',
                  '& > *': {
                    mb: 4,
                  },
                  '& > *:last-of-type': {
                    mb: 0,
                  },
                }}
              >
                {validAddonOffers.map(x => <RecapExtraInsuranceSingle key={x.offerId} offerAddon={x} />)}

              </Box>
            }

            <MeetingRecordCarExtraOverview />
          </MainContent>
        </StepsContent>

        <FormButtons
          leftButtons={
            <Button variant="outline" as='a' href={`${insuranceParamsUrl}/CloneUrl?paramsId=${insuranceParamsId}&replacement=${false}&returnUrl=${encodeURIComponent(`${baseUrl}/carkulka/extra/wizard/1`)}`}>
              <Duplicate color="secondary.500" />
              Klonovat
            </Button>
          }
        />
      </Container>
    </Section>
  )
}

export const CompletedPage = WithAuth(_CompletedPage)